import { Button } from '@/components/ui/button';
import { useInRouterContext, useNavigate } from 'react-router-dom';

interface RouteErrorFallbackProps {
  error?: Error;
  resetError?: () => void;
}

function GoBackButton() {
  const navigate = useNavigate();
  return (
    <Button size="sm" onClick={() => navigate(-1)}>Go Back</Button>
  );
}

export default function RouteErrorFallback({ error, resetError }: RouteErrorFallbackProps) {
  const inRouter = useInRouterContext();

  return (
    <div className="min-h-[50vh] flex items-center justify-center p-6">
      <div className="w-full max-w-md rounded-2xl border border-border bg-card p-6 shadow-sm space-y-4">
        <h2 className="text-lg font-semibold text-foreground">Page failed to load</h2>
        <p className="text-sm text-muted-foreground">
          This page encountered an error, but the rest of the app is still working.
        </p>
        {error?.message && (
          <pre className="text-xs text-muted-foreground break-words rounded-md border border-border bg-muted/50 p-3 whitespace-pre-wrap">
            {error.message}
          </pre>
        )}
        <div className="flex gap-2">
          {resetError && (
            <Button size="sm" variant="outline" onClick={resetError}>Retry</Button>
          )}
          {inRouter && <GoBackButton />}
          <Button size="sm" variant="secondary" onClick={() => window.location.reload()}>Reload</Button>
        </div>
      </div>
    </div>
  );
}
